var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.246,
    height: 22.053
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    stroke: "#687233",
    strokeWidth: 1.5,
    "data-name": "Group 4",
    transform: "translate(.75 1.144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    fill: "none",
    d: "M16.746 67.825H1v-4.67a7.873 7.873 0 1 1 15.746 0Z",
    "data-name": "Path 15",
    transform: "translate(-1 -47.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    fill: "#f4f2ee",
    d: "M24.1 5.771A4.772 4.772 0 1 1 19.325 1 4.77 4.77 0 0 1 24.1 5.771Z",
    "data-name": "Path 14",
    transform: "translate(-11.452 -1.393)"
  }))));
};
export default SvgUser;